export enum SocketEventEnum {
  CONNECT = "connect",
  DISCONNECT = "disconnect",
  LEAD_CREATED = "lead-created",
  ACCOUNT_BILLING_UPDATE = "account-billing-updated",
}
